import script from "./EventProcessTypeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventProcessTypeModal.vue?vue&type=script&setup=true&lang=ts"

import "./EventProcessTypeModal.vue?vue&type=style&index=0&id=18aaf379&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18aaf379"]])

export default __exports__